import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight, MapPin } from 'lucide-react'
import { salons } from '../../config/salons'
import { getSalonThumb } from '../../config/salonImages'
import MegaPeekCard from './MegaPeekCard'

interface MegaSalonsProps {
  lang: string
  onItemClick: () => void
}

export default function MegaSalons({ lang, onItemClick }: MegaSalonsProps) {
  const { t } = useTranslation()
  return (
    <div>
      <div className="flex items-baseline justify-between mb-4 pb-2 border-b border-gold/20">
        <h3 className="font-body font-semibold text-[10px] tracking-[0.25em] text-gold uppercase">
          {t('megaSalons.heading')}
        </h3>
        <Link
          to={`/${lang}/branches`}
          onClick={onItemClick}
          className="inline-flex items-center gap-1 font-body text-[11px] tracking-[0.18em] uppercase text-gold hover:text-mocha transition-colors"
        >
          {t('megaSalons.viewAll')} <ArrowRight size={11} />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {salons.map((salon) => (
          <MegaPeekCard
            key={salon.id}
            to={`/${lang}/salon/${salon.id}`}
            src={getSalonThumb(salon.id)}
            onItemClick={onItemClick}
          >
            <div className="mt-3">
              {/* sr-only keyword anchor text for local SEO ("Frisør i {by}"),
                  no visual change — the visible label stays the brand name. */}
              <span className="sr-only">{t('salonDetail.cityLink', { city: salon.city })}</span>
              <div className="flex items-center gap-1.5">
                <span className="font-display text-sm text-mocha group-hover:text-gold transition-colors duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]">
                  {salon.name}
                </span>
              </div>
              <p className="mt-0.5 font-body text-[11px] text-mocha/55 leading-snug">
                <MapPin size={10} className="inline -mt-0.5 mr-1" aria-hidden="true" />
                {salon.address}
              </p>
              <p className="mt-1 font-body text-[11px] text-mocha/50">
                {t('megaSalons.weekdays')}: {salon.hours.weekdays}
              </p>
            </div>
          </MegaPeekCard>
        ))}
      </div>
    </div>
  )
}
